import React from 'react'
import { Box, Card, CircularProgress, Grid, Typography } from '@mui/material'

const Ncrkpi = ({ data, isLoading, isError }) => {
    if (isLoading) {
        return (
            <Center>
                <CircularProgress />
            </Center>
        );
    }

    if (isError) {
        return (
            <Center>
                <Typography color="error">
                    Failed to load KPI metrics.
                </Typography>
            </Center>
        );
    }

    if (!data) {
        return (
            <Center>
                <Typography>
                    No KPI data available.
                </Typography>
            </Center>
        );
    }
    return (
        <Grid container spacing={1.5} alignItems="stretch">

            <Grid size={3} sx={{ display: "flex" }}>
                <KpiCard title="NCR Issued vs Closed" description="Total number of non-conformance reports (NCRs) raised.">
                    <Row
                        label="Total NCR Reports Raised"
                        value={data?.issuedVsClosed?.totalNCRReportsRaised}
                    />
                    <Row
                        label="Closed NCR Reports"
                        value={data?.issuedVsClosed?.closedNCRReports}
                    />
                </KpiCard>
            </Grid>


            <Grid size={3} sx={{ display: "flex" }}>
                <KpiCard title="NCR Rate (%)" description="Percentage of NCRs resolved out of total raised.">
                    <Row
                        label="Total NCRs"
                        value={data?.closureRate?.totalNCRs}
                    />
                    <Row
                        label="Closed NCRs"
                        value={data?.closureRate?.closedNCRs}
                    />
                    <Row
                        label="Closure Rate (%)"
                        value={`${data?.closureRate?.closureRatePercentage?.toFixed(2)}`}
                    />
                </KpiCard>
            </Grid>


            <Grid size={3} sx={{ display: "flex" }}>
                <KpiCard title="Delay in Resolution of NCR" description="Percentage of NCRs that remain unresolved beyond defined closure period.">
                    <Row
                        label="Major NCRs Pending Beyond Target"
                        value={data?.delayInResolution?.majorNCRsPendingBeyondTarget}
                    />
                    <Row
                        label="Total NCRs Raised"
                        value={data?.delayInResolution?.totalNCRsRaised}
                    />
                </KpiCard>
            </Grid>

            <Grid size={3} sx={{ display: "flex" }}>
                <KpiCard title="Inspection Compliance (%)" description="Evaluates adherence to inspection schedules">
                    <Row
                        label="Inspection Compliance (%)"
                        value={"100"}
                    />
                </KpiCard>
            </Grid>
        </Grid>


    )
}

export default Ncrkpi

const Center = ({ children }) => {
    return (
        <Box
            sx={{
                minHeight: 200,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            {children}
        </Box>
    );
}


const Row = ({ label, value }) => {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "6px",
            }}
        >
            <Typography sx={{ fontSize: "12px", lineHeight: "17px", color: "#64748B" }}>
                {label}
            </Typography>
            <Typography sx={{ ml: 1, fontSize: "13px", lineHeight: "17px", fontWeight: 650, color: "#0F172A" }}>
                {value}
            </Typography>
        </Box>
    );
}


const KpiCard = ({ title, description, children }) => {
    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: "3px",
                border: "1px solid #E2E8F0",
                boxShadow: "0 2px 8px rgba(15, 23, 42, 0.05)",
                width: "100%",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Box sx={{ borderBottom: "1px solid #E4E4E4", px: 1.5, py: 1.25, minHeight: 66 }}>
                <Typography sx={{ fontWeight: 600, fontSize: "15px", lineHeight: "21px", color: "#0F172A" }}>
                    {title}
                </Typography>
                {description && (
                    <Typography
                        sx={{
                            mt: 0.2,
                            fontSize: "11px",
                            color: "#64748B",
                            fontFamily: "Poppins, sans-serif",
                            lineHeight: "16px",
                        }}
                    >
                        {description}
                    </Typography>
                )}
            </Box>

            <Box sx={{ px: 1.5, py: 1.25, flexGrow: 1 }}>
                {children}
            </Box>
        </Card>
    );
}
